<template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-model="item.key"
                  label="Unique Id"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="item.name"
                  label="Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                  :items="vehicleClasses"
                  v-model="item.type"
                  label="Vehicle Class"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="hasCost">
            <v-col cols="12">
              <v-text-field
                  v-model="item.cost"
                  label="Cost (R)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="drivers">
            <v-col cols="12">
              <v-select
                  :items="drivers"
                  v-model="selectedDrivers"
                  item-text="firstName"
                  return-object
                  multiple
                  label="Drivers"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>

</template>

<script>
export default {
  name: "CreateDialog",
  props: {
    formTitle: String,
    item: Object,
    closeFunction: Function,
    saveFunction: Function,
    hasCost: Boolean,
    drivers: Array
  },
  methods: {
    close() {
      this.closeFunction();
    },
    save() {
      this.item.drivers = this.selectedDrivers;
      this.saveFunction(this.item);
    }
  },
  data() {
    return {
      vehicleClasses: ['Truck', 'Skip', 'Roro'],
      selectedDrivers: this.item.drivers ?? []
    };
  },
  mounted() {
    console.log(this.item.drivers)
    this.hasCost = this.hasCost ?? false
  }
}
</script>

<style scoped>

</style>